module.exports = __webpack_public_path__ + "ff13baf33c65d571d85e6970297652a0.pdf";